import { render, staticRenderFns } from "./SiteBlogs.vue?vue&type=template&id=8845d852&"
import script from "./SiteBlogs.vue?vue&type=script&lang=js&"
export * from "./SiteBlogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports